<script setup lang="ts">
import { computed } from 'vue';
import { mediaUrl } from '@/components/Player/mediaUrl';

interface Props {
  /** Rendered size in px. The medallion is square. */
  size?: number;
}

const props = withDefaults(defineProps<Props>(), {
  size: 28,
});

const iconUrl = computed(() => mediaUrl('/media/icons/specialActions/flow-sign.webp'));
</script>

<template>
  <div
    class="flow-sign-mark"
    :style="{ width: `${size}px`, height: `${size}px` }"
    role="img"
    aria-label="Signed with Flow — acting under Game Master authority"
    title="Signed with Flow — acting under Game Master authority"
    data-testid="flow-sign-mark"
  >
    <img :src="iconUrl" alt="" class="flow-sign-mark__img" draggable="false" />
  </div>
</template>

<style scoped>
.flow-sign-mark {
  position: absolute;
  top: 3%;
  right: 3%;
  border-radius: 50%;
  pointer-events: none;
  z-index: 6;
  filter: drop-shadow(0 0 0.15em rgba(255, 140, 40, 0.65));
}

.flow-sign-mark__img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  mix-blend-mode: screen;
  filter: brightness(1.35) saturate(1.3) contrast(1.1);
  user-select: none;
  -webkit-user-drag: none;
}
</style>
